/**
 * Checks whether a results seat map is already cached for any of the given trips.
 * When `expectedPricingVariants` is given, a cached entry only counts when it was loaded
 * for the same pricing context (an absent variant matches only an absent variant), so a
 * one-way map never satisfies a round-trip request and the two round-trip variants never
 * satisfy each other. A variant-scoped entry that only records a failed request is never
 * a hit, so the normal reopen path can retry that context and clear the error; no-variant
 * (legacy) error entries keep the legacy id-only behavior. Without
 * `expectedPricingVariants` the legacy id-only check is preserved.
 * @param {Object} seatsBus - Plain results seat-map state keyed by trip id.
 * @param {Array<string>} tripsSlug - Trip ids to look up.
 * @param {Object} [expectedPricingVariants] - Expected `pricingVariant` per trip id.
 * @returns {boolean} True when a usable cached entry exists.
 */
export default (seatsBus, tripsSlug, expectedPricingVariants) => {
  return tripsSlug.some((tripId) => {
    if (!Object.keys(seatsBus).includes(tripId)) return false;
    if (expectedPricingVariants === undefined) return true;
    const entry = seatsBus[tripId] || {};
    const cachedVariant = entry.pricingVariant ?? undefined;
    if (entry.error && cachedVariant !== undefined) return false;
    return cachedVariant === (expectedPricingVariants[tripId] ?? undefined);
  });
};
